export default __webpack_public_path__ + "static/media/demo_harcsa.cd105918.png";